import { NativeModules, Platform } from 'react-native';
import DeviceInfoProvider from './DeviceInfoProvider';
// eslint-disable-next-line import/no-cycle
import LogModule from './Logging/LogModule';
export function platformSpecificNativeModules() {
    let nativeModules = NativeModules;
    if (Platform.OS === 'web') {
        nativeModules = Object.assign(Object.assign({}, nativeModules), { DeviceInfoProvider, LogModule });
    }
    return nativeModules;
}
export default platformSpecificNativeModules();
//# sourceMappingURL=NativeModules.js.map